import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { CardElement } from '@stripe/react-stripe-js';

export default function PaymentForm() {
  const inputStyle = {
    iconColor: '#c4f0ff',
    color: '#0e0c06',
    fontWeight: '500',
    fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
    fontSize: window.innerWidth > 700 ? '25px' : '15px',
    fontSmoothing: 'antialiased',
    ':-webkit-autofill': {
      color: '#0e0c06',
    },
    '::placeholder': {
      color: 'grey',
    },
  };
  return (
    <Box sx={{ borderTop: 1, mt: 5, pt: 2 }}>
      <Typography variant='primary' gutterBottom sx={{ mt: 2 }}>
        Credit Card
      </Typography>
      <Box sx={{ mt: 5 }}>
        <CardElement
          options={{
            style: {
              base: inputStyle,
            },
          }}
        />
      </Box>
    </Box>
  );
}
